export const stateTableSelectMode = Object.freeze({
  single: 'single',
  multiple: 'multi',
})

export const stateTableEmptyText = 'Нет данных'

export const stateTableSelectModes = () => [stateTableSelectMode.single, stateTableSelectMode.multiple]

export default {
  stateTableSelectMode, stateTableEmptyText
}
